import { loaderSetAction } from "./loaderActionTypes";

export const avLoader = (
  message: string,
  isVisible: boolean
) => (dispatch: any) => {
  dispatch(loaderSetAction({ message, isVisible }));
};
